<template>
  <div v-if="user.roles && (user.roles.includes('*') || userHasResourceAccess(RESOURCENAMES.MANAGEMENT))">
    <AuditLogList/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AuditLogList from './../components/AuditLogList.vue'
import { accessControlMixin } from '../components/mixins/index'

export default {
  mixins:[accessControlMixin],
  data () {
    return {}
  },
  mounted () {

  },
  computed: {
    ...mapGetters(['getUserLoggedIn']),
    user () {
      return this.getUserLoggedIn
    }
  },
  components:{
      AuditLogList
  }
}
</script>
